export default __webpack_public_path__ + "static/media/circle1.4ad5c2a5.svg";